import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M5.12256 9.63232L12.1226 15.6323L19.1226 9.63232"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Icon;
